<template>
  <div class="vx-card p-4">
    <h4 class="mb-4">Manuel Cüzdan Yükleme ve Silme</h4>
    <p class="text-sm text-secondary mb-3 manual-wallet-intro">
      Telefon numarasını başında sıfır olmadan girin; Enter ile arayın. Yalnızca <strong>Manuel Cüzdan Yükleme</strong> yetkisi olan kullanıcılar erişebilir.
      <span class="block mt-2">
        <strong>Bakiye yüklemede</strong> açıklama ve dekont dosyası zorunludur.
        <strong>Bakiye düşürmede</strong> yalnızca açıklama zorunludur; dekont isteğe bağlıdır.
      </span>
    </p>

    <vs-row vs-w="12" class="mb-4 flex flex-wrap items-end">
      <vs-col vs-w="6" vs-sm="12" class="p-1">
        <vs-input
          v-model="telephoneInput"
          label="Telefon"
          placeholder="örn. 5321234567"
          class="w-full"
          @keyup.enter.native="onLookup"
        />
      </vs-col>
      <vs-col vs-w="2" vs-sm="12" class="p-1">
        <vs-button color="primary" class="w-full mt-4" :disabled="lookupLoading" @click="onLookup">
          Ara
        </vs-button>
      </vs-col>
    </vs-row>

    <div v-if="customerSummary" class="manual-wallet-summary vx-card p-4 mb-4">
      <div class="manual-wallet-summary__title">Seçili müşteri</div>
      <vs-row vs-w="12">
        <vs-col vs-w="12" class="mb-3">
          <span class="manual-wallet-summary__name">{{ customerSummary.displayName || "—" }}</span>
          <span class="text-secondary ml-2">{{ customerSummary.telephone }}</span>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="p-1">
          <div class="manual-wallet-field-label">Cüzdan ID</div>
          <div class="manual-wallet-field-value">{{ customerSummary.walletId }}</div>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="p-1">
          <div class="manual-wallet-field-label">Ana bakiye</div>
          <div class="manual-wallet-field-value manual-wallet-field-value--accent">{{ formatTry(customerSummary.amount) }}</div>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="p-1">
          <div class="manual-wallet-field-label">Bonus</div>
          <div class="manual-wallet-field-value">{{ formatTry(customerSummary.bonusAmount) }}</div>
        </vs-col>
      </vs-row>
    </div>

    <div v-if="customerSummary" class="manual-wallet-panel manual-wallet-panel--topup vx-card p-4 mb-4">
      <div class="manual-wallet-panel__head">
        <span class="manual-wallet-panel__badge manual-wallet-panel__badge--success">1</span>
        <div>
          <h5 class="manual-wallet-panel__title">Bakiye yükleme</h5>
          <p class="manual-wallet-panel__hint">
            Tutar girin; <strong>açıklama</strong> ve <strong>dekont dosyası</strong> zorunludur.
          </p>
        </div>
      </div>
      <vs-row vs-w="12" class="flex flex-wrap items-end">
        <vs-col vs-w="12" vs-md="4" class="p-1">
          <vs-input v-model="amountInput" label="Yüklenecek tutar (TL)" placeholder="0,00" class="w-full" />
        </vs-col>
        <vs-col vs-w="12" vs-md="8" class="p-1">
          <label class="manual-wallet-label">Yükleme açıklaması <span class="manual-wallet-req">*</span></label>
          <vs-textarea v-model="topupNote" class="w-full manual-wallet-textarea" height="88px" placeholder="İşlem ve dekont ile ilgili açıklama yazın." />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mt-2 flex flex-wrap items-end">
        <vs-col vs-w="12" vs-md="8" class="p-1">
          <label class="manual-wallet-label">Dekont / belge <span class="manual-wallet-req">*</span></label>
          <div class="manual-wallet-file-wrap">
            <input
              ref="topupFileInput"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
              class="manual-wallet-file-input w-full"
              @change="onTopupFileChange"
            />
          </div>
          <div v-if="topupFileName" class="manual-wallet-file-name">{{ topupFileName }}</div>
        </vs-col>
        <vs-col vs-w="12" vs-md="4" class="p-1">
          <vs-button
            color="success"
            class="w-full mt-4 manual-wallet-action-btn"
            :disabled="topupLoading || deductLoading || !canSubmitTopup"
            @click="onTopup"
          >
            Bakiyeyi yükle
          </vs-button>
        </vs-col>
      </vs-row>
    </div>

    <div v-if="customerSummary" class="manual-wallet-panel manual-wallet-panel--deduct vx-card p-4 mb-4">
      <div class="manual-wallet-panel__head">
        <span class="manual-wallet-panel__badge manual-wallet-panel__badge--danger">2</span>
        <div>
          <h5 class="manual-wallet-panel__title">Bakiye düşürme (silme)</h5>
          <p class="manual-wallet-panel__hint">
            Yalnızca <strong>ana bakiye</strong> düşer (bonus değişmez). Kayıt tipi <strong>Harcama</strong>dır.
            <strong>Açıklama zorunlu</strong>; dekont <strong>isteğe bağlı</strong>.
          </p>
        </div>
      </div>
      <vs-row vs-w="12" class="flex flex-wrap items-end">
        <vs-col vs-w="12" vs-md="4" class="p-1">
          <vs-input
            v-model="deductAmountInput"
            label="Düşürülecek tutar (TL)"
            placeholder="0,00"
            class="w-full"
          />
        </vs-col>
        <vs-col vs-w="12" vs-md="8" class="p-1">
          <label class="manual-wallet-label">Düşüm açıklaması <span class="manual-wallet-req">*</span></label>
          <vs-textarea
            v-model="deductNote"
            class="w-full manual-wallet-textarea"
            height="88px"
            placeholder="Örn. müşteri talebi, düzeltme, iç mutabakat notu."
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mt-2 flex flex-wrap items-end">
        <vs-col vs-w="12" vs-md="8" class="p-1">
          <label class="manual-wallet-label">Dekont / belge <span class="manual-wallet-opt">(isteğe bağlı)</span></label>
          <div class="manual-wallet-file-wrap">
            <input
              ref="deductFileInput"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
              class="manual-wallet-file-input w-full"
              @change="onDeductFileChange"
            />
          </div>
          <div v-if="deductFileName" class="manual-wallet-file-name">{{ deductFileName }}</div>
        </vs-col>
        <vs-col vs-w="12" vs-md="4" class="p-1">
          <vs-button
            color="danger"
            class="w-full mt-4 manual-wallet-action-btn"
            :disabled="deductLoading || topupLoading || !canSubmitDeduct"
            @click="onDeduct"
          >
            Bakiyeden düş
          </vs-button>
        </vs-col>
      </vs-row>
    </div>

    <div v-if="customerSummary" class="manual-wallet-history mt-2">
      <h5 class="manual-wallet-history__title mb-2">Cüzdan işlem geçmişi</h5>
      <div class="text-sm text-secondary mb-2">Toplam {{ txRowCount }} kayıt</div>
      <vs-table :data="txItems" :max-items="pageSize" class="mb-2 manual-wallet-tx-table">
        <template slot="thead">
          <vs-th class="th-narrow">Tarih</vs-th>
          <vs-th class="th-narrow">Tip</vs-th>
          <vs-th class="th-narrow">Tutar</vs-th>
          <vs-th class="th-narrow">Belge</vs-th>
          <vs-th class="th-desc">Açıklama</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="row in data" :key="row.id">
            <vs-td class="td-narrow">{{ formatDate(row.date) }}</vs-td>
            <vs-td class="td-narrow">{{ transactionTypeLabel(row.transactionType) }}</vs-td>
            <vs-td class="td-narrow">{{ formatTry(row.price) }}</vs-td>
            <vs-td class="td-narrow td-doc">
              <a
                v-if="attachmentHref(row)"
                :href="attachmentHref(row)"
                target="_blank"
                rel="noopener noreferrer"
                class="text-primary"
              >Görüntüle</a>
              <span v-else>—</span>
            </vs-td>
            <vs-td class="td-desc">{{ row.description || "—" }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        v-if="maxPage > 1"
        class="mt-2"
        :total="maxPage"
        :max="7"
        v-model="currentPage"
      />
    </div>
  </div>
</template>

<script>
import {
  manualWalletLookup,
  manualWalletTransactions,
  manualWalletTopup,
  manualWalletDeduct
} from "@/api/WalletManual";

export default {
  name: "ManualWalletTopup",
  data() {
    return {
      telephoneInput: "",
      lookupLoading: false,
      topupLoading: false,
      customerSummary: null,
      amountInput: "",
      topupNote: "",
      topupFile: null,
      topupFileName: "",
      deductAmountInput: "",
      deductNote: "",
      deductFile: null,
      deductFileName: "",
      deductLoading: false,
      txItems: [],
      txRowCount: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    maxPage() {
      if (this.txRowCount <= 0) return 1;
      return Math.ceil(this.txRowCount / this.pageSize);
    },
    canSubmitTopup() {
      const noteOk = (this.topupNote || "").trim().length > 0;
      const fileOk = this.topupFile instanceof File;
      const amountOk = this.parseAmount() != null;
      return Boolean(this.customerSummary && noteOk && fileOk && amountOk);
    },
    canSubmitDeduct() {
      const noteOk = (this.deductNote || "").trim().length > 0;
      const amountOk = this.parseDeductAmount() != null;
      return Boolean(this.customerSummary && noteOk && amountOk);
    }
  },
  watch: {
    currentPage() {
      if (this.customerSummary && this.customerSummary.customerId) {
        this.loadTransactions();
      }
    }
  },
  methods: {
    formatTry(v) {
      if (v === null || v === undefined) return "—";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
    },
    formatDate(v) {
      if (!v) return "—";
      return new Date(v).toLocaleString("tr-TR");
    },
    transactionTypeLabel(t) {
      const map = { 0: "Yatırma", 1: "Harcama", 2: "İade", 3: "Bonus", Yatirma: "Yatırma", Harcama: "Harcama", Iade: "İade", Bonus: "Bonus" };
      return map[t] != null ? map[t] : String(t);
    },
    notifyError(text) {
      this.$vs.notify({ color: "danger", title: "Hata", text: text || "İşlem başarısız" });
    },
    notifySuccess(text) {
      this.$vs.notify({ color: "success", title: "Başarılı", text: text || "Tamamlandı" });
    },
    firstError(res) {
      const errs = res && res.data && res.data.errors;
      if (errs && errs.length) return errs[0].message || errs[0].Message;
      return null;
    },
    async onLookup() {
      const tel = (this.telephoneInput || "").trim();
      if (!tel) {
        this.notifyError("Telefon numarası giriniz.");
        return;
      }
      this.lookupLoading = true;
      this.customerSummary = null;
      this.txItems = [];
      this.txRowCount = 0;
      this.currentPage = 1;
      try {
        const res = await manualWalletLookup(tel);
        const body = res && res.data;
        const ok = body && (body.result === true || body.Result === true);
        if (!ok) {
          this.notifyError(this.firstError(res) || "Kullanıcı bulunamadı");
          return;
        }
        const d = body.data || body.Data;
        this.customerSummary = {
          customerId: d.customerId || d.CustomerId,
          displayName: d.displayName || d.DisplayName,
          telephone: d.telephone || d.Telephone,
          walletId: d.walletId || d.WalletId,
          amount: d.amount != null ? d.amount : d.Amount,
          bonusAmount: d.bonusAmount != null ? d.bonusAmount : d.BonusAmount
        };
        this.resetTopupExtras();
        this.resetDeductExtras();
        await this.loadTransactions();
      } catch (e) {
        this.notifyError("Sunucuya ulaşılamadı.");
      } finally {
        this.lookupLoading = false;
      }
    },
    async loadTransactions() {
      if (!this.customerSummary || !this.customerSummary.customerId) return;
      try {
        const res = await manualWalletTransactions(
          this.customerSummary.customerId,
          this.currentPage,
          this.pageSize
        );
        const body = res && res.data;
        const ok = body && (body.result === true || body.Result === true);
        if (!ok) {
          this.notifyError(this.firstError(res) || "İşlemler yüklenemedi");
          this.txItems = [];
          this.txRowCount = 0;
          return;
        }
        const paged = body.data || body.Data;
        const results = (paged && (paged.results || paged.Results)) || [];
        this.txItems = results;
        this.txRowCount = (paged && (paged.rowCount != null ? paged.rowCount : paged.RowCount)) || 0;
      } catch (e) {
        this.notifyError("İşlemler yüklenemedi.");
        this.txItems = [];
        this.txRowCount = 0;
      }
    },
    parseAmount() {
      const raw = (this.amountInput || "").replace(",", ".").trim();
      const n = parseFloat(raw);
      if (Number.isNaN(n) || n <= 0) return null;
      return n;
    },
    parseDeductAmount() {
      const raw = (this.deductAmountInput || "").replace(",", ".").trim();
      const n = parseFloat(raw);
      if (Number.isNaN(n) || n <= 0) return null;
      return n;
    },
    resetTopupExtras() {
      this.topupNote = "";
      this.topupFile = null;
      this.topupFileName = "";
      if (this.$refs.topupFileInput) {
        this.$refs.topupFileInput.value = "";
      }
    },
    resetDeductExtras() {
      this.deductAmountInput = "";
      this.deductNote = "";
      this.deductFile = null;
      this.deductFileName = "";
      if (this.$refs.deductFileInput) {
        this.$refs.deductFileInput.value = "";
      }
    },
    onTopupFileChange(e) {
      const f = e && e.target && e.target.files && e.target.files[0];
      if (f) {
        this.topupFile = f;
        this.topupFileName = f.name;
      } else {
        this.topupFile = null;
        this.topupFileName = "";
      }
    },
    onDeductFileChange(e) {
      const f = e && e.target && e.target.files && e.target.files[0];
      if (f) {
        this.deductFile = f;
        this.deductFileName = f.name;
      } else {
        this.deductFile = null;
        this.deductFileName = "";
      }
    },
    attachmentHref(row) {
      const rel = (row && (row.attachmentUrl || row.AttachmentUrl)) || "";
      if (!rel) return "";
      const base = (process.env.VUE_APP_ROOT_API || "").replace(/\/+$/, "");
      const path = String(rel).replace(/^\/+/, "");
      return `${base}/${path}`;
    },
    async onTopup() {
      if (!this.customerSummary || !this.customerSummary.customerId) {
        this.notifyError("Önce müşteri arayın.");
        return;
      }
      const amount = this.parseAmount();
      if (amount == null) {
        this.notifyError("Geçerli bir tutar girin.");
        return;
      }
      const note = (this.topupNote || "").trim();
      if (!note) {
        this.notifyError("Açıklama zorunludur.");
        return;
      }
      if (!(this.topupFile instanceof File)) {
        this.notifyError("Belge / dekont dosyası yüklemeniz zorunludur.");
        return;
      }
      this.topupLoading = true;
      try {
        const fd = new FormData();
        fd.append("customerId", this.customerSummary.customerId);
        fd.append("amount", String(amount));
        fd.append("note", note);
        fd.append("file", this.topupFile);
        const res = await manualWalletTopup(fd);
        const body = res && res.data;
        const ok = body && (body.result === true || body.Result === true);
        if (!ok) {
          this.notifyError(this.firstError(res) || "Yükleme başarısız");
          return;
        }
        const d = body.data || body.Data;
        if (d) {
          this.customerSummary.amount = d.amount != null ? d.amount : d.Amount;
          this.customerSummary.bonusAmount = d.bonusAmount != null ? d.bonusAmount : d.BonusAmount;
          this.customerSummary.walletId = d.walletId != null ? d.walletId : d.WalletId;
        }
        this.amountInput = "";
        this.resetTopupExtras();
        this.notifySuccess("Bakiye yüklendi.");
        this.currentPage = 1;
        await this.loadTransactions();
      } catch (e) {
        this.notifyError("Sunucuya ulaşılamadı.");
      } finally {
        this.topupLoading = false;
      }
    },
    async onDeduct() {
      if (!this.customerSummary || !this.customerSummary.customerId) {
        this.notifyError("Önce müşteri arayın.");
        return;
      }
      const amount = this.parseDeductAmount();
      if (amount == null) {
        this.notifyError("Geçerli bir tutar girin.");
        return;
      }
      const note = (this.deductNote || "").trim();
      if (!note) {
        this.notifyError("Açıklama zorunludur.");
        return;
      }
      const confirmText = `Bu müşterinin ana bakiyesinden ${this.formatTry(
        amount
      )} düşülsün mü? Bu işlem geri alınamaz.`;
      if (typeof window !== "undefined" && !window.confirm(confirmText)) {
        return;
      }
      this.deductLoading = true;
      try {
        const fd = new FormData();
        fd.append("customerId", this.customerSummary.customerId);
        fd.append("amount", String(amount));
        fd.append("note", note);
        if (this.deductFile instanceof File) {
          fd.append("file", this.deductFile);
        }
        const res = await manualWalletDeduct(fd);
        const body = res && res.data;
        const ok = body && (body.result === true || body.Result === true);
        if (!ok) {
          this.notifyError(this.firstError(res) || "Düşüm başarısız");
          return;
        }
        const d = body.data || body.Data;
        if (d) {
          this.customerSummary.amount = d.amount != null ? d.amount : d.Amount;
          this.customerSummary.bonusAmount = d.bonusAmount != null ? d.bonusAmount : d.BonusAmount;
          this.customerSummary.walletId = d.walletId != null ? d.walletId : d.WalletId;
        }
        this.resetDeductExtras();
        this.notifySuccess("Bakiye düşürüldü.");
        this.currentPage = 1;
        await this.loadTransactions();
      } catch (e) {
        this.notifyError("Sunucuya ulaşılamadı.");
      } finally {
        this.deductLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.manual-wallet-intro strong {
  font-weight: 600;
}

.manual-wallet-summary {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.02);
}

.manual-wallet-summary__title {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.manual-wallet-summary__name {
  font-size: 1.125rem;
  font-weight: 600;
}

.manual-wallet-field-label {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.manual-wallet-field-value {
  font-size: 1rem;
  font-weight: 500;
}

.manual-wallet-field-value--accent {
  font-size: 1.25rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.manual-wallet-panel {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
}

.manual-wallet-panel--topup {
  border-left: 4px solid #16a34a;
  background: linear-gradient(to right, rgba(22, 163, 74, 0.06), rgba(255, 255, 255, 0.98));
}

.manual-wallet-panel--deduct {
  border-left: 4px solid #dc2626;
  background: linear-gradient(to right, rgba(220, 38, 38, 0.06), rgba(255, 255, 255, 0.98));
}

.manual-wallet-panel__head {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.manual-wallet-panel__badge {
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 700;
  color: #fff;
}

.manual-wallet-panel__badge--success {
  background: #16a34a;
}

.manual-wallet-panel__badge--danger {
  background: #dc2626;
}

.manual-wallet-panel__title {
  margin: 0 0 0.35rem 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.manual-wallet-panel__hint {
  margin: 0;
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.58);
  line-height: 1.45;
}

.manual-wallet-label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.72);
  margin-bottom: 0.35rem;
}

.manual-wallet-req {
  color: #dc2626;
  font-weight: 700;
}

.manual-wallet-opt {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.75rem;
}

.manual-wallet-textarea >>> textarea {
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px;
}

.manual-wallet-file-wrap {
  padding: 0.5rem 0.65rem;
  border: 1px dashed rgba(0, 0, 0, 0.22);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
}

.manual-wallet-file-name {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 0.35rem;
}

.manual-wallet-action-btn {
  font-weight: 600;
}

.manual-wallet-history__title {
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.manual-wallet-file-input {
  padding: 0.15rem 0;
  font-size: 0.875rem;
}

/* vuesax: .vs-con-table > table */
.manual-wallet-tx-table >>> .vs-con-table table,
.manual-wallet-tx-table >>> table {
  table-layout: fixed;
  width: 100%;
}

.manual-wallet-tx-table >>> thead .th-narrow,
.manual-wallet-tx-table >>> tbody .td-narrow {
  max-width: 150px;
  width: 150px;
  box-sizing: border-box;
  vertical-align: top;
  font-size: 0.8125rem;
}

.manual-wallet-tx-table >>> tbody .td-narrow {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  font-variant-numeric: tabular-nums;
}

.manual-wallet-tx-table >>> thead .th-desc,
.manual-wallet-tx-table >>> tbody .td-desc {
  width: auto;
  min-width: 0;
  max-width: none;
  vertical-align: top;
  word-break: break-word;
  white-space: normal;
}
</style>
